import React from "react";
import { Screen, ScreenHeader, ScreenBody, screenConnect } from "@screen";
import { ModalButton, ModalIconLink } from "@modal";
import LoadingSpinner from "@js/components/studio/utilities/loading_spinner.jsx";

import {
  ceScreenViewWebVersionCancel,
  ceScreenViewWebVersionToggleReplacementCodes,
} from "@js/actions/studio/campaign_content_section/screen_view_web_version.js";

const ScreenViewWebVersion = (props) => {
  return (
    <Screen>
      <ScreenHeader>
        <div
          style={{
            paddingLeft: "19px",
            paddingTop: "12px",
            display: "inline-block",
            float: "left",
          }}
        >
          <ModalIconLink
            icon="cogs"
            onClick={() => props.dispatch(ceScreenViewWebVersionToggleReplacementCodes())}
          >
            {props.show_replacements ? t("phrases.show_replacement_codes") : t("phrases.hide_replacement_codes")}
          </ModalIconLink>
        </div>
        <div
          style={{
            paddingRight: "19px",
            paddingTop: "12px",
            display: "inline-block",
            float: "right",
          }}
        >
          <ModalButton
            onClick={() => props.dispatch(ceScreenViewWebVersionCancel())}
            text={t("buttons.cancel")}
            diminished
          />
        </div>
      </ScreenHeader>
      <ScreenBody style={{ backgroundColor: "#EEE", overflowY: "hidden" }}>
        {
          ( props.is_error ) ? (
            <div className="inline-notice inline-error">
              { t("alerts.generic_server_error") }
            </div>
          ) : ( props.is_loading ) ? (
            <LoadingSpinner width="25px" height="25px" />
          ) : (
            <iframe
              id="screenViewWebVersion"
              style={{
                width: "100%",
                maxWidth: "900px",
                minHeight: "500px",
                height: "100%",
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
                backgroundColor: "#FFF",
              }}
              srcDoc={props.show_replacements ? props.replaced_html :  props.plain_html}
            />
          )
        }
      </ScreenBody>
    </Screen>
  );
};

export default screenConnect(ScreenViewWebVersion);
